/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/wp-content/themes/larkin-university/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _custom = __webpack_require__(1);

var _custom2 = _interopRequireDefault(_custom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_custom2.default.init();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _header = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// @NOTE: assumes jQuery is included by WP
var $ = jQuery;

var $window = $(window);

var Custom = function () {
  function Custom() {
    _classCallCheck(this, Custom);
  }

  _createClass(Custom, [{
    key: 'init',
    value: function init() {
      this.Header = new _header.header();
    }
  }, {
    key: 'onWindowResize',
    value: function onWindowResize(windowWidth) {
      // all methods that respond to window resize should be here
      //this.Header.onWindowResize(windowWidth)
    }
  }, {
    key: 'onWindowScroll',
    value: function onWindowScroll(scrollTop) {
      // all methods that respond to window scroll should be here
      // this.Header.onWindowScroll(scrollTop)
    }
  }, {
    key: 'onWindowLoad',
    value: function onWindowLoad() {}
  }, {
    key: 'onPageShow',
    value: function onPageShow() {
      // this.Header.onPageShow()
    }
  }]);

  return Custom;
}();

var custom = new Custom();

var resizeThreshold;
$window.resize(function () {
  clearTimeout(resizeThreshold);
  resizeThreshold = setTimeout(function () {
    custom.onWindowResize($window.width());
  }, 100);
});

$window.scroll(function () {
  custom.onWindowScroll(window.scrollY);
});

$(document).ready(function () {
  custom.onWindowResize($window.width());
});

window.onload = function () {
  custom.onWindowLoad();
};

window.onpageshow = function (event) {
  if (event.persisted) {
    custom.onPageShow();
    // window.location.reload();
  }
};

exports.default = custom;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__(3);

Object.defineProperty(exports, 'header', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_header).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// @NOTE: assumes jQuery is included by WP
var $ = jQuery;

var header = function () {
  function header() {
    _classCallCheck(this, header);

    this.$mobileNavButton = $(".mobile-btn");
    this.$closeMobileButton = $(".close-mobile-nav");
    this.$mobileNavBg = $(".mobile-nav-bg-curtain");
    this.$siteHeader = $(".header-primary");
    this.$megaMenuList = $('.mega-menu');
    this.$megaMenu = $('.mega-menu > span');
    this.$menuItemHasChildren = $('.menu-item-has-children > a');
    this.$menuLink = $('.elementor-nav-menu .menu-item-has-children > a');

    var delay = 100;setTimeout(function () {
      $('.elementor-tab-title').removeClass('elementor-active');
      $('.elementor-tab-content').css('display', 'none');
    }, delay);

    this.$mobileNavButton.click(function () {
      $(".navigation").addClass('menu-open');
      $(".mobile-nav-bg-curtain").addClass('menu-open');
    });

    this.$closeMobileButton.click(function () {
      $(".navigation").removeClass('menu-open');
      $(".mobile-nav-bg-curtain").removeClass('menu-open');
    });

    this.$mobileNavBg.click(function () {
      $(".navigation").removeClass('menu-open');
      $(".mobile-nav-bg-curtain").removeClass('menu-open');
    });

    /* If mobile browser, prevent click on parent nav item from redirecting to URL */
    // if(is_touch_device()) {

    //     $('.main-menu-wrapper li > ul').each(function (index, elem) {
    //         /* Option 1: Use this to modify the href on the <a> to # */
    //         //$(elem).prev('a').attr('href' ,'#');   

    //         /* OR Option 2: Use this to keep the href on the <a> intact but prevent the default action */
    //         $(elem).prev('a').click(function(event) {
    //             event.preventDefault();
    //         });
    //     });
    // }

    setTimeout(function () {
      $('.spinner-decimal').prev('.input-group-addon').addClass('addon-icon').css('display', 'table-cell');
      $('.spinner-decimal').parents('.col-md-6').addClass('addon-icon-wrapper');
      $('.checkout_products_wrap').prev('h3').addClass('card-title');
      console.log();
    }, 1500);

    this.mobileMenuToggle();
  }

  _createClass(header, [{
    key: "mobileMenuToggle",
    value: function mobileMenuToggle() {
      this.$menuItemHasChildren.on('click', function (event) {
        var windowWidth = $(window).width();
        if (windowWidth < 1024) {
          event.preventDefault();
          if ($(event.currentTarget).hasClass('clicked')) {
            var pageLink = $(event.currentTarget).attr('href');
            window.location.href = pageLink;
          }
          $(event.currentTarget).next('.sub-menu').slideToggle();
          $(event.currentTarget).toggleClass('clicked');
        }
      });
    }
  }, {
    key: "onWindowScroll",
    value: function onWindowScroll(scrollTop) {
      if (scrollTop >= 20) {
        this.$siteHeader.addClass('js-fixed-header');
      } else {
        this.$siteHeader.removeClass('js-fixed-header');
      }
    }

    // onWindowResize (windowWidth) {
    //   this.$menuItemHasChildren.on('click', (event) => {
    //     event.preventDefault()    
    //     if(windowWidth < 1024) { 
    //       $(event.currentTarget).next('.sub-menu').toggleClass('show')  
    //     }
    //   })  
    // }

  }]);

  return header;
}();

exports.default = header;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/custom.js